import { ModuleOption, InformationCodes } from '@/data/enums'
import GlassOptionValue from './glass-option-value'

export const informationCodes = {
  [`option_${ModuleOption.Colormatic}`]: InformationCodes.ModuleColormatic,
  [`option_${ModuleOption.Monoplus}`]: InformationCodes.ModuleMonoplus,
  [`option_${ModuleOption.Pro410}`]: InformationCodes.ModulePro410,
  [`option_${ModuleOption.MDM}`]: InformationCodes.ModuleMDM,
  [`option_${ModuleOption.Prisma}`]: InformationCodes.ModulePrisma

}

export const optionIcons = {
  [`option_${ModuleOption.Colormatic}`]: 'options-coloring',
  [`option_${ModuleOption.Monoplus}`]: 'options-monoplus',
  [`option_${ModuleOption.Pro410}`]: 'options-pro410',
  [`option_${ModuleOption.MDM}`]: 'options-mdm',
  [`option_${ModuleOption.Prisma}`]: 'options-prisma'
}

export const optionRoutes = {
  [`option_${ModuleOption.Coating}`]: '/glasses/coating',
  [`option_${ModuleOption.Suncoating}`]: '/glasses/suncoating',
  [`option_${ModuleOption.Color}`]: '/glasses/color',
  [`option_${ModuleOption.Colormatic}`]: '/glasses/extra',
  [`option_${ModuleOption.Dneye}`]: '/glasses/dneye',
  [`option_${ModuleOption.Ergo}`]: '/glasses/ergo',
  [`option_${ModuleOption.Lifestyle}`]: '/glasses/lifestyle',
  [`option_${ModuleOption.Polarised}`]: '/glasses/polarised',
  [`option_${ModuleOption.Suncolor}`]: '/glasses/color',
  [`option_${ModuleOption.Sunthickness}`]: '/glasses/thickness',
  [`option_${ModuleOption.Thickness}`]: '/glasses/thickness',
  [`option_${ModuleOption.Monoplus}`]: '/glasses/extra',
  [`option_${ModuleOption.Pro410}`]: '/glasses/extra',
  [`option_${ModuleOption.MDM}`]: '/glasses/extra',
  [`option_${ModuleOption.Road}`]: '/glasses/extra',
  [`option_${ModuleOption.Prisma}`]: '/glasses/extra'
}

export function getInformationCode (optionId: ModuleOption): string | null {
  if (informationCodes.hasOwnProperty(`option_${optionId}`)) {
    return informationCodes[`option_${optionId}`]
  } else {
    return null
  }
}

export function getOptionIcon (optionId: ModuleOption): string | null {
  if (optionIcons.hasOwnProperty(`option_${optionId}`)) {
    return optionIcons[`option_${optionId}`]
  } else {
    return null
  }
}

export function getOptionRoute (optionId: ModuleOption): string {
  if (optionRoutes.hasOwnProperty(`option_${optionId}`)) {
    return optionRoutes[`option_${optionId}`]
  } else {
    return '/glasses/glass'
  }
}

export default class GlassOption {
  public id!: string
  public icon?: string
  public optionId!: ModuleOption
  public name!: string
  public fullscreen: number | null = 0
  public typeId!: string
  public values: GlassOptionValue[] = []
}
